<template>
  <div class="box-item shadow2 mx-auto">
    <div
      class="user-img w-100"
      style="position: relative;"
      :style="{ backgroundImage: 'url(' + item.resources_image.data + ')' }"
    >
      <div class="best-seller">
        <span>Más vendido</span>
      </div>
      <div class="certi" v-if="item.data.free == '1'">
        <img src="/image/resource/3_icon_png.png" width="57px" alt="" />
      </div>
    </div>
    <div class="divider-line w-100"></div>
    <div class="item-title">{{ item.courses.name }}</div>
    <div class="item-description">
      {{ item.course_owner.name }} {{ item.course_owner.lastname }}
    </div>
    <div class="item-action">
      
      <span class="flex items-stretchinline-flex w-100">
        <span>
          <User fill="#848484" stroke="#848484" />   
        </span>
        <span >
          {{ item.users_in_course }}  
        </span>
        <span class="pl-3 pr-1">
          <calendar  fill="#848484" stroke="#848484" />
        </span>
        <span >
          {{ moment(item.date_in).format("DD/MM/YYYY") }}
        </span>
      </span>

      
    </div>
    <!-- <div class="item-prize">US$ {{ item.data.price }}</div> -->

    <div class="row item-group">
      <div class="item-button col" @click="showDetail">
        <span class="item-buy-icon">
          <img
            class="icon-img-cart"
            src="/image/resource/shoppingc_black.svg"
            alt=""
          />
        </span>
        <div class="item-buy-text">VER MÁS</div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../../v2/src/components/icons/User.vue";
import Calendar from "../../v2/src/components/icons/Calendar.vue";
export default {
  name: "item",
  components: {
    User,
    Calendar
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    image: "image/courses/user.png"
  }),
  methods: {
    showDetail: function() {
      this.$router.push({ 
        name: "Detail", 
        params: { 
          slug: this.item.courses.name.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,''),
        },
        query: {course: this.item.id}
      });
    },
    addCart() {
      this.$store.dispatch("shopingCart/addCart", this.item);
    }
  }
};
</script>

<style scoped>
.box-item {
  margin-left: 15px;
  margin-right: 15px;
  width: 280px;
  border-radius: 0px 0px 10px 10px;
  background: #ffffff 0% 0% no-repeat padding-box;
}

.certi {
  position: absolute;
  bottom: 10px;
  right: 6px;
}
.user-img {
  height: 171px;
  background-position: center;
  background-size: cover;
}

.shadow2 {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.divider-line {
  height: 6px;
  background: transparent linear-gradient(87deg, #156a92 0%, #3db7bb 100%) 0% 0%
    no-repeat padding-box;
}

.item-title,
.item-description {
  text-align: left;
  padding: 0 15px;
}

.item-action {
  text-align: center;
  padding: 0 15px;
}

.item-title {
  height: 54px;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  margin-top: 6px;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.item-description {
  color: #686868;
  font-size: 15px;
  margin-bottom: 17px;
  overflow: hidden;
  padding-right: 5px;
}

.item-action {
  color: #686868;
  margin-bottom: 16px;
  font-size: 14px;
}

.item-action span {
  font-size: 15px;
}
.item-action i {
  font-size: 20px;
}

.item-action .far {
  color: #446daf;
}

.item-prize {
  color: #ff001f;
  font-size: 23px;
  text-align: right;
  font-weight: 900;
  margin-right: 31px;
  margin-bottom: 6px;
}

.item-button {
  width: calc(100% - 32px);
  height: 37px;
  background: #446daf 0% 0% no-repeat padding-box;
  border-radius: 0px 5px 5px 0px;
  margin-left: 16px !important;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.icon-img-cart {
  width: 20px !important;
}

.item-buy-icon {
  margin-left: -32px;
  width: 37px;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent linear-gradient(90deg, #f1946d 0%, #de337a 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 19px;
  z-index: 1;
}

.item-group {
  margin-left: 35px !important;
  width: calc(100% - 65px);
  cursor: pointer;
  transition: 0.1s all;
  border-radius: 18px 0px 18px 18px;
}
/*
.item-group:hover {
  cursor: pointer;
  box-shadow: 0px 2px 5px #00000029;
} */

.item-buy-text {
  color: white;
  padding-left: 50px;
  font-size: 15px;
  font-weight: 500;
}

.best-seller {
  position: relative;
  background: #ea560e 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 2px #00000066;
  display: inline;
  top: 5px;
  left: 13px;
  color: #ffffff;
  border-radius: 4px;
  font-size: 11px;
  font-family: "Roboto-Bold", sans-serif;
  text-transform: uppercase;
  padding: 2px 8px 3px 9px;
}
</style>
